<template lang="pug">
.crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
  .container-fluid
    vm-row(vm-w="12")
      vm-col.card(vm-sm=12)
        vm-table(max-height="350px" :data="manufacturings")
          template(slot="header")
            .d-flex.justify-content-between
              vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilterManufacture(filters)" width="300px")
              .d-flex.justify-content-between
                vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                  vm-dropdown(ref="dropdown" vm-custom-content vm-trigger-click vm-trigger-outside-click)
                    vm-button(type="default" icon="funnel-outline" size="small")

                    vm-dropdown-menu(class="filters")
                      .heading.d-flex.justify-content-between
                        h4 {{ $t('strings.filters') }}
                        vm-button(type="flat" size="small" @click="clearFilterManufacture") {{ $t('strings.clear') }}
                      vm-select.filter(:placeholder="$t('customer_purchase_orders.production_status_display')" autocomplete :label="$t('customer_purchase_orders.production_status_display')" v-model="filters.where.production_status_id")
                        vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in productionStatus")
                      vm-select.filter(:placeholder="$t('customer_purchase_orders.production_area_display')" autocomplete :label="$t('customer_purchase_orders.production_area_display')" v-model="filters.where.production_area_id")
                        vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in productionAreas")
                      vm-select.filter(:placeholder="$t('customer_purchase_orders.delivery_status')" autocomplete :label="$t('customer_purchase_orders.delivery_status')" v-model="filters.where.delivery_status")
                        vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in deliverTime")
                      //- Add filters
                          Agrega los filtros que prefieras por ejemplo:
                          vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                            vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")

                          NOTA: (agregar clase .filter)
                      .filter.d-flex
                        vm-button(@click="applyFilterManufacture(filters)") {{ $t('strings.apply') }}
                vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="applyFilterManufacture(filters)" size="small" width="200px" :serializer="item => $t('manufacturings.'+ item)")
                vm-tooltip(:text="$t('strings.display_list')" delay=".5s")
                  vm-button(type="default" size="small" icon="list" style="display: none;")
                vm-tooltip(:text="$t('strings.display_grid')" delay=".5s")
                  vm-button(type="default" size="small" icon="grid" color="rgba(var(--gray),1)" style="display: none;")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('customer_purchase_order_details.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in manufacturings")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'unit_price' || column == 'amount' ")  {{data[indextr][column] | currency }}
                slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column == 'delivery_date'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                slot(v-if="column == 'name'")  {{data[indextr][column]}}
                slot(v-if="column == 'number'")  {{data[indextr]['purchase_order']['number']}}
                slot(v-if="column == 'folio'")  {{data[indextr]['purchase_order']['folio']}}
                slot(v-if="column == 'requisitor'")  {{data[indextr]['purchase_order']['requisitor']}}
                slot(v-if="column == 'invoiced_amount'") {{data[indextr][column]}} / {{data[indextr]['quantity']}}
                slot(v-if="column == 'currency_display'") {{data[indextr][['purchase_order']['currency_display']]}}
                slot(v-if="column != 'finished_date' && column != 'paint_date' && column != 'enabled_date' && column != 'fold_die_cut_date' && column != 'forged_date' && column != 'amount' && column != 'invoiced_amount' && column != 'delivery_status' && column != 'production_area_display' && column != 'created_at' && column != 'name' && column != 'role' && column != 'total' && column != 'unit_price' && column != 'delivery_date'") {{data[indextr][column]}}
                vm-date-picker(v-if="column == 'finished_date' || column == 'paint_date' || column == 'enabled_date' || column == 'fold_die_cut_date' || column == 'forged_date'" type="date" @on-change="updateDate(data[indextr], column, data[indextr][column])" v-model="data[indextr][column]" :placeholder="$t('customer_purchase_order_details.'+column)")
                vm-select(class="select-manufacturing" v-if="column == 'production_area_display'" v-model="data[indextr].production_area_id" @input="statusArea(data[indextr], 'updateArea')" :style="stylesAreas(data[indextr].production_area_id)")
                  vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in productionAreas")
                vm-select(class="select-manufacturing" v-if="column == 'delivery_status'" v-model="data[indextr].delivery_status" @input="statusTime(data[indextr], 'updateDelivery')" :style="styleTimes(data[indextr].delivery_status)")
                  vm-select-item(v-if="data[indextr].production_status_id != 2" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in deliverTime2")
                  vm-select-item(v-if="data[indextr].production_status_id == 2" :key="index" :value="item.value" :text="item.text" v-for="(item,index) in deliverTime")
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="editRecord(data[indextr], tr)")
                    vm-icon(icon="edit-2-outline")
                    slot &nbsp;{{ $t('strings.edit') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] == 'Inactivo'" @click="setActionRecord(data[indextr], 'actived')")
                    vm-icon(icon="person-done-outline")
                    slot &nbsp;{{ $t('strings.action_active') }}
                  vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status'] === 'Inactivo'" @click="deleteRecordConfirm(data[indextr])")
                    vm-icon(icon="trash-2-outline")
                    slot &nbsp;{{ $t('strings.delete') }}
                  //- More actions
        vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
        transition(name="enter")
          .total-records(v-if="total>0") Total: {{ total | currency }}
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
import parseVuexObject from '@/utils/parseVuexObject'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectsDashboard')

export default {
  name: 'ManufacturingDashboard',
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: [
      'created_at',
      'customer_name',
      'number',
      'purchase_order_folio',
      'requisitor',
      'quantity',
      'invoiced_amount',
      'name',
      'production_area_display',
      'forged_date',
      'fold_die_cut_date',
      'enabled_date',
      'paint_date',
      'finished_date',
      'delivery_status',
      'unit_price',
      'amount'
    ],
    columnsOrderBy: ['customer_display'],
    attributeModal: 'customer_display',
    status: [],
    deliverTime: [
      {
        text: 'Cancelado',
        value: 'cancelled'
      },
      {
        text: 'Entrega a destiempo',
        value: 'mistime'
      },
      {
        text: 'A tiempo',
        value: 'on_time'
      },
      {
        text: 'Entregado',
        value: 'delivered'
      }
    ],
    deliverTime2: [
      {
        text: 'Cancelado',
        value: 'cancelled'
      },
      {
        text: 'Entrega a destiempo',
        value: 'mistime'
      },
      {
        text: 'A tiempo',
        value: 'on_time'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        name: '',
        purchase_order: {
          folio: ''
        },
        production_status_id: '',
        production_area_id: '',
        delivery_status: '',
        param: ''
      },
      whereIn: {

        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...mapGetters(['manufacturings', 'catalog', 'pagination', 'filterManufacturing', 'productionStatus', 'productionAreas', 'currentPage'])
  },
  watch: {
    filterManufacturing (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      if (this.filters.where.delivery_status === 'delivered') {
        this.loadRecordsManufacture({ page: this.currentPage, id: this.$route.params.id, param: '' })
      }
      this.loadRecordsManufacture({ page: this.currentPage, id: this.$route.params.id, param: 'delivery_status!=delivered' })
    },
    currentPage (currentPage) {
      this.loadRecordsManufacture({ page: currentPage, id: this.$route.params.id, param: 'delivery_status!=delivered' })
    }
  },
  async created () {
    this.loadRecordsManufacture({ page: 1, id: this.$route.params.id, param: 'delivery_status!=delivered' })
    await this.loadProductionStatus()
    await this.loadProductionArea()
    await this.getRecords(1)
  },
  methods: {
    ...mapActions([
      'loadRecordsManufacture',
      'applyFilterManufacture',
      'clearFilterManufacture',
      'loadFacturingCatalog',
      'loadProductionStatus',
      'loadProductionArea',
      'updateStatus',
      'exportManufature'
    ]),
    statusArea (data) {
      this.updateStatus({ ...data, production_area_id: data.production_area_id })
    },
    statusTime (data) {
      this.updateStatus({ ...data, delivery_status: data.delivery_status })
    },
    styles (code) {
      switch (code) {
        case 1:
          return { color: '#D06325' }
        case 2:
          return { color: 'rgb(23, 201, 100)' }
        case 3:
          return { color: '#afbbc6' }
        case 4:
          return { color: 'rgb(242, 19, 93)' }
        default:
          return { color: '#D06325' }
      }
    },
    stylesAreas (code) {
      switch (code) {
        case 1:
          return { color: '#D06325' }
        case 2:
          return { color: 'rgb(23, 201, 100)' }
        case 3:
          return { color: '#afbbc6' }
        case 4:
          return { color: 'rgb(242, 19, 93)' }
        default:
          return { color: '#D06325' }
      }
    },
    styleTimes (code) {
      switch (code) {
        case 'on_time':
          return { color: 'rgb(23, 201, 100)' }
        case 'mistime':
          return { color: 'rgb(206, 176, 14)' }
        case 'cancelled':
          return { color: 'red' }
        default:
          return { color: '#D06325' }
      }
    },
    updateDate (data, key, value) {
      this.updateField(data, key, moment(value).format('YYYY-MM-DD'))
    },
    updateField (data, field, value) {
      this.convertAllDates(data)
      this.updateStatus({ ...data, [field]: value })
    },
    convertAllDates (data) {
      Object.keys(data).forEach((key) => {
        if (key.includes('_date') && data[key]) {
          data[key] = moment(data[key]).format('YYYY-MM-DD')
        }
      })
    }
  }
}
</script>
<style lang="scss">

.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.select-manufacturing {
  .vm-select--input {
    width: 150px;
    font-weight: bold;
  }
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
